import { render, staticRenderFns } from "./SangsangLogin.vue?vue&type=template&id=4dccac7e&scoped=true&"
import script from "./SangsangLogin.vue?vue&type=script&lang=js&"
export * from "./SangsangLogin.vue?vue&type=script&lang=js&"
import style0 from "./SangsangLogin.vue?vue&type=style&index=0&id=4dccac7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dccac7e",
  null
  
)

export default component.exports